import { Routes } from '@angular/router';
import { customerWriteGuard } from './core/guards/customer-write.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/ih-home',
    pathMatch: 'full'
  },
  
  // Main IH Pages
  {
    path: 'ih-home',
    loadComponent: () => import('./pages/ih-home/ih-home.component').then(m => m.IhHomeComponent)
  },
  // Redesign: all-policies list ("Policies" tab)
  {
    path: 'ih-policies',
    loadComponent: () => import('./pages/ih-policies/ih-policies.component').then(m => m.IhPoliciesComponent)
  },
  // Redesign: pay picker ("Pay" tab) — same list component, pay mode
  {
    path: 'ih-pay',
    data: { mode: 'pay' },
    loadComponent: () => import('./pages/ih-policies/ih-policies.component').then(m => m.IhPoliciesComponent)
  },
  // Redesign: profile ("Profile" tab)
  {
    path: 'ih-profile',
    loadComponent: () => import('./pages/ih-profile/ih-profile.component').then(m => m.IhProfileComponent)
  },
  // Redesign: profile sub-pages (read-only)
  {
    path: 'ih-personal-info',
    loadComponent: () => import('./pages/ih-personal-info/ih-personal-info.component').then(m => m.IhPersonalInfoComponent)
  },
  {
    path: 'ih-payment-history',
    loadComponent: () => import('./pages/ih-payment-history/ih-payment-history.component').then(m => m.IhPaymentHistoryComponent)
  },
  {
    path: 'ih-help',
    loadComponent: () => import('./pages/ih-help/ih-help.component').then(m => m.IhHelpComponent)
  },
  {
    path: 'ih-policy/:policyNo',
    loadComponent: () => import('./pages/ih-policy/ih-policy.component').then(m => m.IhPolicyComponent)
  },
  {
    path: 'ih-policy-detail/:policyNo',
    loadComponent: () => import('./pages/ih-policy-detail/ih-policy-detail.component').then(m => m.IhPolicyDetailComponent)
  },
  
  // Product Detail
  {
    path: 'ih-product-detail/:productId',
    loadComponent: () => import('./pages/ih-product-detail/ih-product-detail.component').then(m => m.IhProductDetailComponent)
  },
  
  // Premium Payment
  {
    path: 'ih-pay-premium/:policyNo',
    loadComponent: () => import('./pages/ih-pay-premium/ih-pay-premium.component').then(m => m.IhPayPremiumComponent)
  },
  {
    path: 'ih-pay-premium-success/:policyNo',
    loadComponent: () => import('./pages/ih-pay-premium-success/ih-pay-premium-success.component').then(m => m.IhPayPremiumSuccessComponent)
  },
  {
    path: 'ih-pay-premium-history/:policyNo',
    loadComponent: () => import('./pages/ih-pay-premium-history/ih-pay-premium-history.component').then(m => m.IhPayPremiumHistoryComponent)
  },
  {
    path: 'ih-premium-schedul/:policyNo',
    loadComponent: () => import('./pages/ih-premium-schedul/ih-premium-schedul.component').then(m => m.IhPremiumSchedulComponent)
  },
  
  // Bonus
  {
    path: 'ih-bonus-cashback/:policyNo',
    loadComponent: () => import('./pages/ih-bonus-cashback/ih-bonus-cashback.component').then(m => m.IhBonusCashbackComponent)
  },
  {
    path: 'ih-bonus-history',
    loadComponent: () => import('./pages/ih-bonus-history/ih-bonus-history.component').then(m => m.IhBonusHistoryComponent)
  },
  
  // Accident Claims
  {
    path: 'ih-claim-accident-create/:policyNo',
    canActivate: [customerWriteGuard],
    loadComponent: () => import('./pages/ih-claim-accident-create/ih-claim-accident-create.component').then(m => m.IhClaimAccidentCreateComponent)
  },
  {
    path: 'ih-claim-accident-list/:policyNo',
    loadComponent: () => import('./pages/ih-claim-accident-list/ih-claim-accident-list.component').then(m => m.IhClaimAccidentListComponent)
  },
  {
    path: 'ih-claim-accident-update/:policyNo/:claimId',
    loadComponent: () => import('./pages/ih-claim-accident-update/ih-claim-accident-update.component').then(m => m.IhClaimAccidentUpdateComponent)
  },
  
  // Death Claims
  {
    path: 'ih-claim-dead-create/:policyNo',
    canActivate: [customerWriteGuard],
    loadComponent: () => import('./pages/ih-claim-dead-create/ih-claim-dead-create.component').then(m => m.IhClaimDeadCreateComponent)
  },
  {
    path: 'ih-claim-dead-list/:policyNo',
    loadComponent: () => import('./pages/ih-claim-dead-list/ih-claim-dead-list.component').then(m => m.IhClaimDeadListComponent)
  },
  {
    path: 'ih-claim-dead-update/:policyNo/:claimId',
    loadComponent: () => import('./pages/ih-claim-dead-update/ih-claim-dead-update.component').then(m => m.IhClaimDeadUpdateComponent)
  },
  
  // Policy Cancellation
  {
    path: 'ih-policy-cancel-create/:policyNo',
    canActivate: [customerWriteGuard],
    loadComponent: () => import('./pages/ih-policy-cancel-create/ih-policy-cancel-create.component').then(m => m.IhPolicyCancelCreateComponent)
  },
  {
    path: 'ih-policy-cancel-list/:policyNo',
    loadComponent: () => import('./pages/ih-policy-cancel-list/ih-policy-cancel-list.component').then(m => m.IhPolicyCancelListComponent)
  },
  {
    path: 'ih-policy-cancel-detail/:policyNo/:cancellationId',
    loadComponent: () => import('./pages/ih-policy-cancel-detail/ih-policy-cancel-detail.component').then(m => m.IhPolicyCancelDetailComponent)
  },
  
  // Policy Change Requests
  {
    path: 'ih-policy-change-request-create/:policyNo',
    canActivate: [customerWriteGuard],
    loadComponent: () => import('./pages/ih-policy-change-request-create/ih-policy-change-request-create.component').then(m => m.IhPolicyChangeRequestCreateComponent)
  },
  {
    path: 'ih-policy-change-request-detail/:policyNo/:requestId',
    loadComponent: () => import('./pages/ih-policy-change-request-detail/ih-policy-change-request-detail.component').then(m => m.IhPolicyChangeRequestDetailComponent)
  },
  {
    path: 'ih-policy-change-request-list/:policyNo',
    loadComponent: () => import('./pages/ih-policy-change-request-list/ih-policy-change-request-list.component').then(m => m.IhPolicyChangeRequestListComponent)
  },
  
  // Notification Center (Phase 5 / C3)
  {
    path: 'ih-notifications',
    loadComponent: () => import('./pages/ih-notifications/ih-notifications.component').then(m => m.IhNotificationsComponent)
  },

  // Legacy Dashboard (if needed)
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent)
  },
  
  // Fallback
  {
    path: '**',
    redirectTo: '/ih-home'
  }
];



